'use client';

import { useState } from 'react';

import { Option } from '@lichtblick/types';

import { ManuallyManagedSegmentedButton } from './ManuallyManagedSegmentedButton';

export type SegmentedButtonProps = {
  defaultValue?: string;
  label?: string;
  onOptionChange: (value: string) => void;
  options: Option[];
  value?: string;
  variant?: 'tabs' | 'buttons';
};

export const SegmentedButton = ({ defaultValue, onOptionChange, value, ...props }: SegmentedButtonProps) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue ?? '');

  const resolvedValue = value ?? selectedValue;

  return (
    <ManuallyManagedSegmentedButton
      {...props}
      onOptionChange={(nextValue) => {
        if (value === undefined) {
          setSelectedValue(nextValue);
        }

        onOptionChange(nextValue);
      }}
      value={resolvedValue}
    />
  );
};
